import { Component, OnInit, OnDestroy } from '@angular/core';
import { ItemService } from './../../services/item.service';
import { Router } from '@angular/router';
import { Spot } from '../../models/Item';
import { Chart } from 'chart.js';

@Component({
  selector: 'app-activity-dashboard',
  templateUrl: './activity-dashboard.component.html',
  styleUrls: ['./activity-dashboard.component.css']
})
export class ActivityDashboardComponent implements OnInit {

  constructor(public itemService: ItemService, public router: Router) { }

  chart = [];

  // public data: any[];
  // dateSelected: any;
  public daterange: any = {};
  public advertiser: any;
  public options: any = {
    locale: { format: 'MM/DD/YYYY' },
    
    alwaysShowCalendars: true,
    startDate: this.itemService.sd,
    endDate: this.itemService.ed,
    minDate: '01/01/2017',
    // maxDate: '31/03/2018',
    opens: 'left',
    showWeekNumbers: true,
    ranges: {
      // 'Yesterday': [
      //     '2018-02-26T07:00:33.456Z',
      //     '2018-02-26T07:00:33.456Z'
      // ],
      'Last 7 Days': [ 
        '01/01/2017',
        '31/03/2018',
      ],
      'Last 30 Days': [
        '03/02/2018',
        '03/31/2018'
      ],
      'This Month': [
        '03/01/2018',
        '03/31/2018'
      ],
      'Last Month': [
        '02/01/2018',
        '02/28/2018'
      ]
    },
  };


  

  public selectedDate(value: any, datepicker?: any) {
    datepicker.start = value.start;
    datepicker.end = value.end;

    // or manupulat your own internal property
    this.daterange.start = value.start;
    this.daterange.end = value.end;
    this.daterange.label = value.label;

    let start;
    let end;
    start = new Date(this.daterange.start);
    end = new Date(this.daterange.end);

    // start Date Function
    const sd_date = ('0' + start.getDate()).slice(-2);
    const sd_Month = ('0' + (start.getMonth() + 1)).slice(-2);
    const sd_year = start.getFullYear();

    const startDate = ((sd_Month) + '-' + sd_date + '-' + sd_year);
    this.itemService.startDate = startDate;
    // console.log(this.itemService.startDate);

    // end Date Function
    const ed_date = ('0' + end.getDate()).slice(-2);
    const ed_Month = ('0' + (end.getMonth() + 1)).slice(-2);
    const ed_year = end.getFullYear();

    const endDate = ((ed_Month) + '-' + ed_date + '-' + ed_year);
    this.itemService.endDate = endDate;
    // console.log(this.itemService.endDate);

    // dateChanged Function

    // let parameters:any = { 
    //   section_name: 'Industry',
    //   page_name: 'Dashboard',
    //   startDate: this.itemService.startDate,
    //   days: Math.round(Math.abs((start.getTime() - end.getTime())/(24*60*60*1000))),
    //   endDate: this.itemService.endDate,
    // }

    // this.itemService.logEvent('onDateChange', parameters);

    // this.itemService.dateChangeDetector();
   
  }

  onChange(value) {

    if(value === 'today') this.itemService.userActivityData = this.itemService.dailyActivity; 
    if(value === 'week') this.itemService.userActivityData = this.itemService.weeklyActivity; 
    if(value === 'month') this.itemService.userActivityData = this.itemService.monthlyActivity; 
  }


  ngOnInit() {
    this.itemService.showSpinner = true;
    // this.itemService.events = this.itemService.userActivity();
    this.itemService.aggregatedLogs = this.itemService.logsAggregation();
    this.itemService.userActivityData = this.itemService.dailyActivity;
    this.itemService.showSpinner = false
  }

}



// WEBPACK FOOTER //
// ./src/app/activity/activity-dashboard/activity-dashboard.component.ts